import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';

import Banner from './../Elements/Banner';

var bnrimg = require('./../../images/s1/b1.png');

class Services_1 extends React.Component {
    render() {
        return (
            <>
                <Header />
                <div className="page-content ">
                    <Banner title="Prepared. Protected. Fire Ready." pagename="Fire Extinguisher Services" bgimage={bnrimg} />

                    <div className="section-full p-tb80 inner-page-padding">
                        <div className="container">
                            <div className="blog-single-wrap-width">
                                <div className="blog-post date-style-3 blog-detail text-black">
                                    <div className="mt-post-media clearfix m-b30">
                                        <ul className="grid-post">
                                            <li>
                                                <div className="portfolio-item">
                                                    <img className="img-responsive" src={require("./../../images/s1/b2.png")} alt="" />
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="mt-post-title ">
                                        <h3 className="post-title font-weight-600">Fire Extinguisher Services</h3>
                                    </div>

                                    <div className="mt-post-text">
                                        <p><strong>“Preparedness is not a plan. It's a habit.” – US Navy Safety Command</strong></p>

                                        <p>
                                            Fire extinguishers are your first and fastest defense in a fire emergency. At <strong>I-Smart Engineering Works</strong>, we specialize in the complete lifecycle of fire extinguishers — from consultation and supply to maintenance and refilling.
                                        </p>

                                        <p>
                                            Our trained technicians ensure that your extinguishers are always ready when seconds matter most. Whether it’s ABC Dry Powder, CO₂, Foam, or Water-based extinguishers — we service all types with precision and care.
                                        </p>

                                        <h4 className="font-weight-600">Our Services Include:</h4>
                                        <ul className="list-angle-right">
                                            <li>New extinguisher supply and certified installation</li>
                                            <li>Inspection, tagging, and ISI revalidation</li>
                                            <li>Refilling and pressure testing</li>
                                            <li>Annual Maintenance Contracts (AMC)</li>
                                            <li>Strategic placement as per NBC & IS 2190</li>
                                        </ul>

                                        <blockquote className="bg-dark text-white author-quote">
                                            <h4 className="m-b0">“Fire doesn’t wait. Neither do we.” <i className="fa fa-quote-right" /></h4>
                                            <div className="p-t15 text-white">
                                                <strong className="text-primary">Chief Petty Officer (Ret.)</strong>
                                                <span>Indian Navy</span>
                                            </div>
                                        </blockquote>

                                        <p>
                                            We’re trusted by industries, schools, hospitals, and residential complexes across India. Our reliability, documentation, and 24/7 support make us a preferred fire safety partner.
                                        </p>
                                        <p>
                                            <strong>Pro Tip:</strong> Keep your extinguishers visible, accessible, and regularly inspected. Book a free site visit now and let us take care of the rest.
                                        </p>
                                    </div>

                                    <div className="autor-post-tag-share bdr-t-1 bdr-solid bdr-gray p-t20">
                                        <div className="row">
                                            <div className="col-md-6 col-sm-6">
                                                <div className="widget widget_tag_cloud">
                                                    <h4 className="tagcloud">Tags</h4>
                                                    <div className="tagcloud">
                                                        <NavLink>Fire Extinguisher</NavLink>&nbsp;
                                                        <NavLink>Refilling</NavLink>&nbsp;
                                                        <NavLink>Fire Safety</NavLink>&nbsp;
                                                        <NavLink>AMC</NavLink>&nbsp;
                                                        <NavLink>Fire Protection</NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </>
        );
    }
}

export default Services_1;
